import React, { useCallback, useState } from "react";

import useTranslation from "next-translate/useTranslation";
import cn from "classnames";

import { Button } from "@shopify/polaris";

import Title from "../../components/Title";
import DiscordFillIcon from "../../icons/DiscordFill";

import {
  DISCORD_EMAIL_BOT_LINK,
  DISCORD_TG_BOT_LINK,
} from "../../../../../../utils/constants";

import styles from "./styles.module.scss";

import installStepTG1 from "/public/discord/install-1@2x.png";
import installStepTG2 from "/public/discord/install-2@2x.png";
import installStepTG3 from "/public/discord/install-3@2x.png";
import installStepEmail1 from "/public/discord/email/how-install-1@2x.png";
import installStepEmail2 from "/public/discord/email/how-install-2@2x.png";
import installStepEmail3 from "/public/discord/email/how-install-3@2x.png";
import { DISCORD_TELEGRAM_NAMESPACE } from "../../../../../../utils/i18nNameSpaces";

const STEP_BG_TG = [installStepTG1, installStepTG2, installStepTG3];
const STEP_BG_EMAIL = [installStepEmail1, installStepEmail2, installStepEmail3];

const Index = ({ namespace }) => {
  const [active, setActive] = useState(0);
  const { t } = useTranslation(namespace);

  const steps = useCallback(
    (stepNum) => {
      return Object.values(
        t(`how-to-install.slides.${stepNum}.steps`, {}, { returnObjects: true })
      );
    },
    [t]
  );

  const SLIDES = [
    {
      image:
        namespace === DISCORD_TELEGRAM_NAMESPACE
          ? installStepTG1
          : installStepEmail1,
      title: t("how-to-install.slides._1.title"),
      steps: steps("_1"),
      button: {
        icon: DiscordFillIcon,
        url:
          namespace === DISCORD_TELEGRAM_NAMESPACE
            ? DISCORD_TG_BOT_LINK
            : DISCORD_EMAIL_BOT_LINK,
        label: t(
          namespace === DISCORD_TELEGRAM_NAMESPACE
            ? "actions.add-to-server"
            : "actions.start-trial"
        ),
      },
    },
    {
      image:
        namespace === DISCORD_TELEGRAM_NAMESPACE
          ? installStepTG2
          : installStepEmail2,
      title: t("how-to-install.slides._2.title"),
      steps: steps("_2"),
    },
    {
      image:
        namespace === DISCORD_TELEGRAM_NAMESPACE
          ? installStepTG3
          : installStepEmail3,
      title: t("how-to-install.slides._3.title"),
      steps: steps("_3"),
    },
  ];

  const handleArrow =
    (value = 1) =>
    () => {
      setActive((state) => {
        const newState = state + value;

        if (newState < 0) {
          return 0;
        }
        if (newState > SLIDES.length - 1) {
          return SLIDES.length - 1;
        }

        return newState;
      });
    };

  return (
    <section className={styles["HowToInstall__root"]}>
      <Title>{t("how-to-install.title")}</Title>
      <div className={styles["slides"]}>
        {SLIDES.map((slide, i) => (
          <div
            className={cn(styles["slide"], {
              [styles["active"]]: active === i,
            })}
            key={i}
          >
            <div className={styles["image_root"]}>
              <div
                className={styles["image"]}
                style={{
                  backgroundImage: `url(${
                    namespace === DISCORD_TELEGRAM_NAMESPACE
                      ? STEP_BG_TG[i].src
                      : STEP_BG_EMAIL[i].src
                  })`,
                }}
              />
              {i === 0 && (
                <span onClick={handleArrow(-1)} className={styles["arrow"]} />
              )}
              {i === SLIDES.length - 1 && (
                <span
                  onClick={handleArrow(1)}
                  className={cn(styles["arrow"], styles["right"])}
                />
              )}
            </div>
            <ul>
              <li>
                <h3>
                  <span>{i + 1}.</span>
                  {slide.title}
                </h3>
              </li>
              {slide.steps.map((step, i) => (
                <li key={i}>
                  <p>{step}</p>
                </li>
              ))}
            </ul>
            {slide.button ? (
              <Button
                url={slide.button.url}
                size="large"
                primary
                external
                fullWidth
                icon={slide.button.icon}
              >
                {slide.button.label}
              </Button>
            ) : null}
          </div>
        ))}
      </div>
    </section>
  );
};

export default Index;
